<template>
  <template v-if="null !== data">
    <Breadcrumbs :breadcrumbs="buildBreadcrumbs(data.post)" />
    <PostBase
      :post="data.post"
      :latest-posts="data.latest"
      :current-route="{
        routeName: RouteNames.BLOG_POST,
        params: {
          postSlug: route.params.postSlug,
        },
      }"
    />
  </template>
</template>

<script setup>
import Breadcrumbs from "~/modules/shared/breadcrumbs/Breadcrumbs.vue";
import { useStrapiApi } from "~/uses/useMyFetch";
import {
  getPostQuery,
  getPostsQuery,
} from "~/nuxt_modules/blog/utils/query.utils";
import PostBase from "~/nuxt_modules/blog/ui/pages/Post/PostBase.vue";
import { useBlogStore } from "~/nuxt_modules/blog/store/blog.store.js";
import { RouteNames } from "~/nuxt_modules/common/config/route.config.js";

const route = useRoute();
const { fetchTags } = useBlogStore();

const { data } = await useAsyncData(
  "fetchPostData",
  async () => {
    const [post, latest] = await Promise.all([
      useStrapiApi(
        `/blog/posts/slug/${route.params.postSlug}?${getPostQuery()}`,
      ).catch(() => {
        return {
          data: null,
        };
      }),
      useStrapiApi(
        `/blog/posts?${getPostsQuery({ page: 1, pageSize: 4 })}`,
      ).catch(() => {
        return {
          data: [],
        };
      }),
      fetchTags(),
      useStrapiApi(`/blog/posts/seen/${route.params.postSlug}`, {
        method: "POST",
        server: false,
      }),
    ]);

    return {
      post: post.data,
      latest: latest.data,
    };
  },
  { watch: [() => route.params.postSlug], immediate: true },
);

if (null === data.value.post) {
  throw showError({
    statusCode: 404,
    statusMessage: "Post doesn't exist",
  });
}

const buildBreadcrumbs = (post) => {
  return [
    {
      name: "@Blog",
      routeName: RouteNames.BLOG_HOME,
    },
    {
      name: post.title ?? "Null",
      routeName: RouteNames.BLOG_POST,
      params: {
        postSlug: route.params.postSlug,
      },
    },
  ];
};
</script>
